import { phpRequest } from "./phpRequest";
import { request as goRequest } from "./request"
import { nubisGorequest } from './nubisGorequest'
import localforage from 'localforage';
// 门店相关API
const StoreApi = {
  // 获取门店tree 列表
  GetStoreTreeList: async(company_id) => {
    const res = await phpRequest.get('/groups/tree',{
      company_id: company_id
    })
    return res;
  },
  // 获取门店列表
  GetList:(data) => {
    return phpRequest.post('/groups/list',data,{
      showLoading: true
    })
  },
  // 删除门店
  Remove: (id,companyId) => {
    return phpRequest.delete("/groups/delete", {
      id: id,
      company_id: companyId
    },{
      showLoading: true
    });
  },
  // 删除一些门店
  RemoveSome: (ids,companyId) => {
    return phpRequest.post("/groups/deleteSome", {
      ids: ids,
      company_id: companyId
    },{
      showLoading: true
    });
  },
  // 更新状态
  UpdateStatus: (status,ids=[]) => {
    return phpRequest.post("/groups/updatestatus", {
      ids: ids,
      status: status
    },{
      showLoading: true
    });
  },

  // 获取门店账号列表
  GetStoreAccount: (params) => {
    return phpRequest.get("/groups/user/list", {
      ...params
    },{
      showLoading: true
    });
  },

  // 获取列设置
  GetTableColumnConfig: (params) => {
    return phpRequest.get("/config/user-config", {
      ...params
    },{
      showLoading: true
    });
  },
  // 列设置相关接口
  SetTableColumnConfig: (data) => {
    return phpRequest.post("/config/set-user-config", {
      ...data
    },{
      showLoading: true
    });
  },
  // 获取门店配置信息
  GetStoreSettingInfo : (data) => {
    // return new Promise((resolve, reject) => {
    //   const res = {
    //     "configs": [
    //       {
    //         "osType": "android",
    //         "namingRuleId": "c3985876-1322-4707-9c30-f084d53c4b53",
    //         "namingRuleName": "命名规则名称test1",
    //         "configId": "",
    //         "configHistoryId": "",
    //         "configName": "",
    //         "namingRuleDelimiter": "-",
    //         "namingRuleRules": "[{\"type\":1,\"value\":\"我的设备\"},{\"type\":2,\"startValue\":1},{\"type\":3}]"
    //       },
    //       {
    //         "osType": "windows",
    //         "namingRuleId": "",
    //         "namingRuleName": "",
    //         "configId": "",
    //         "configHistoryId": "",
    //         "configName": "",
    //         "namingRuleDelimiter": "",
    //         "namingRuleRules": ""
    //       }
    //     ]
    //   }
    //   resolve(res)
    // })
    return nubisGorequest.post('/fec/nubis/v3/group_info',{
      ...data
    })
  },

  // 获取门店token
  GetStoreSettingToken : (data) => {
    // return new Promise(resolve => {
    //   const  res = {"groupToken":"6537662","companyToken":"279737"}
    //   resolve(res)
    // })
    return nubisGorequest.post('/fec/nubis/v3/get_group_token',{
      ...data
    },{
      showLoading: true
    })
  },

  // 刷新token

  RefreshToken: (data) => {
    // return new Promise(resolve => {
    //   const  res = {token : Math.ceil(Math.random()* 10000000)}
    //   resolve(res)
    // })
    return nubisGorequest.post('/fec/nubis/v3/renew_group_token',{
      ...data
    },{
      showLoading: true
    })
  },

  // 导出json
  handleExportToken : (data) => {
    const JSONText = JSON.stringify(
      data,
      null,
      1
    );
    const blob = new Blob([JSONText], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "token.json";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  },

  // 获取门店详情
  GetDetail : (param) => {
    return phpRequest.get('/groups/edit',param,{
      showLoading: true
    })
  },

  // 保存门店详情
  StoreEdit : (data) => {
    return phpRequest.put('/groups/updateinfo',data,{
      showLoading: true
    })
  },

  StoreAdd : () => {

  },

  // 导入门店
  StoreImport : (data) => {
    return phpRequest.post('/groups/upload',data,{
      showLoading: true
    })
  },

  // 导出门店
  StoreExport: (param) => {
    return phpRequest.get('/groups/download',param,{
      responseType: "blob",
      showLoading: true
    })
  }

}
export default StoreApi
